import React, { useEffect, useState } from 'react';
import dayjs from 'dayjs';

import LoadingButton from '@mui/lab/LoadingButton';
import SearchIcon from '@material-ui/icons/Search';
import { makeStyles, createStyles } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';

import { MeasureInfoType, SelectDataType } from './FeatureParameter';
import { ItemComboBox, ComboBoxItemType } from '../../atoms/ComboBox/ItemComboBox';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles(
  createStyles({
    buttonStyle: {
      width: '100px',
    },
  })
);

//計測種別リスト作成
const CreateMeasureList = (data: MeasureInfoType[]): ComboBoxItemType[] => {
  var ret: ComboBoxItemType[] = [];
  if (data != null) {
    // 重複を取り除く処理
    console.debug(data);

    var devNameList = data.filter(
      (el: MeasureInfoType, index, self) =>
        self.findIndex(
          (e: MeasureInfoType) => e.DevNo === el.DevNo && e.DevIndex === el.DevIndex && e.DevName === el.DevName
        ) === index
    );

    console.debug(devNameList);

    for (var i in devNameList) {
      ret.push({ index: devNameList[i].id, name: `${devNameList[i].DevNo} ${devNameList[i].DevName}` });
    }
  }
  return ret;
};

//年選択コンボボックス作成
const CreateYearList = (): ComboBoxItemType[] => {
  var ret: ComboBoxItemType[] = [];
  var n = new Date();
  var y = dayjs(n).format('YYYY');

  for (let i = 0; i < 100; i++) {
    y = dayjs(n).format('YYYY');
    ret.push({ index: Number(y), name: y });
    console.debug(y);
    if (y === '2019') {
      break;
    }
    n = dayjs(n).subtract(1, 'year').toDate();
  }

  console.debug(ret);
  return ret;
};

//月選択コンボボックス作成
const CreateMonthList = (): ComboBoxItemType[] => {
  var ret: ComboBoxItemType[] = [];
  for (let i = 0; i < 12; i++) {
    ret.push({ index: i + 1, name: `${i + 1}` });
  }
  console.debug(ret);
  return ret;
};

type Props = {
  selectData: SelectDataType;
  mesInfoList: MeasureInfoType[];
  onChangeSelectDataEvent: (selectData: SelectDataType) => void;
  loading: boolean;
};

const FeatureParameterSelectItem: React.FC<Props> = (props) => {
  const { t } = useTranslation();
  const classes = useStyles();
  const [mesList, setMesList] = React.useState<ComboBoxItemType[]>([]);
  const [yearList, setYearList] = React.useState<ComboBoxItemType[]>([]);
  const [monthList, setMonthList] = React.useState<ComboBoxItemType[]>([]);
  const [selectData, setSelectData] = useState<SelectDataType>(props.selectData);

  //コンボボックスデータ作成
  useEffect(() => {
    if (props.mesInfoList.length !== 0) {
      var mesList: ComboBoxItemType[] = [];
      var yList: ComboBoxItemType[] = [];
      var mList: ComboBoxItemType[] = [];

      mesList = CreateMeasureList(props.mesInfoList);
      yList = CreateYearList();
      mList = CreateMonthList();

      setMesList(mesList);
      setYearList(yList);
      setMonthList(mList);
    }
  }, [props.mesInfoList]);

  const handleMesSelectChange = (event: React.ChangeEvent<{ name?: string; value: unknown }>) => {
    var mes = props.mesInfoList.find((item) => item.id === Number(event.target.value));
    if (mes !== undefined) {
      setSelectData({
        ...selectData,
        mesid: mes.id,
      });
    }
  };
  const handleYearSelectChange = (event: React.ChangeEvent<{ name?: string; value: unknown }>) => {
    setSelectData({ ...selectData, year: Number(event.target.value) });
  };

  const hadleMonthSelectChange = (event: React.ChangeEvent<{ name?: string; value: unknown }>) => {
    console.debug(event.target.value);
    setSelectData({ ...selectData, month: Number(event.target.value) });
  };

  const handleDispButtonClick = () => {
    props.onChangeSelectDataEvent(selectData);
  };

  return (
    <Box display="flex" alignItems="center" justifyContent="flex-start">
      <div style={{ width: 10 }}></div>
      <ItemComboBox
        label={t('FeatureParameterSelectItem.機器','機器：')}
        itemList={mesList}
        value={selectData.mesid}
        onChangeEvent={handleMesSelectChange}
      />
      <div style={{ width: 20 }}></div>
      <ItemComboBox label={t('FeatureParameterSelectItem.年','年：')} itemList={yearList} value={selectData.year} onChangeEvent={handleYearSelectChange} />
      <div style={{ width: 20 }}></div>
      <ItemComboBox
        label={t('FeatureParameterSelectItem.月','月：')}
        itemList={monthList}
        value={selectData.month}
        onChangeEvent={hadleMonthSelectChange}
      />
      <div style={{ width: 100 }}></div>
      <LoadingButton
        className={classes.buttonStyle}
        loading={props.loading}
        loadingPosition="start"
        variant="contained"
        color="primary"
        startIcon={<SearchIcon />}
        onClick={handleDispButtonClick}
      >
        {t('FeatureParameterSelectItem.表示','表示')}
      </LoadingButton>
    </Box>
  );
};

export default FeatureParameterSelectItem;
